import React from "react";
import { useTranslation } from "react-i18next";

const FilterButton = ({ name, isActive, clickHandler }) => {
  const { t } = useTranslation();
  if (!name) return null;

  const displayName = name === "all epks" ? t("All EPKs") : name;

  return (
    <button
      type="button"
      onClick={() => clickHandler(name, isActive)}
      className={`tw-px-4 tw-py-1.5 tw-rounded-full tw-text-sm tw-font-medium tw-transition-colors tw-border tw-cursor-pointer tw-whitespace-nowrap ${
        isActive
          ? "tw-bg-[#712CB0] tw-text-white tw-border-[#712CB0]"
          : "tw-bg-transparent tw-text-white/60 tw-border-white/20 hover:tw-text-white hover:tw-border-white/40"
      }`}
    >
      {displayName}
    </button>
  );
};

export default FilterButton;
